import React from 'react';
import Copyright from './Copyright';
import FooterLinks from './FooterLinks';
import styles from './Footer.css';
import HorizontalRule from './HorizontalRule';
import VfcLogo from '../assets/PoweredByVFC';

const Footer = () => ({
  render() {
    return (
      <div className={styles.footer}>
        <VfcLogo />
        <HorizontalRule />
        <FooterLinks />
        <HorizontalRule />
        <Copyright />
      </div>
    );
  },
});

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx